module.exports = __webpack_public_path__ + "media/assets/icons/cp-1fd8c5d129e52ab3fcf2f6e7b4eb2525.svg";